import { apiZoho } from '#plugins/axios.js';

export const getClientByDocument = async (doc) => {
  const response = await apiZoho.get('Clientes_Report', {
    params: {
      where: `Documento=="${doc}"`,
    },
  });

  return response.data.data[0];
};
